const ar = {
  meta: {
    title: "معرض أعمال — بلال القطراوي",
    description:
      "مطوّر واجهات أمامية متخصص في React.js و Next.js — منصات SaaS ولوحات تحكم وتجارة إلكترونية باستخدام Tailwind و MUI وتكامل API جاهز للإنتاج.",
  },
  common: {
    logo: "بلال",
    loading: "جاري تحميل التجربة…",
    viewDemo: "موقع مباشر",
    viewCode: "المصدر",
    submit: "إرسال الرسالة",
    sending: "جاري الإرسال…",
    language: "اللغة",
    theme: "المظهر",
  },
  nav: {
    home: "الرئيسية",
    about: "من أنا",
    skills: "المهارات",
    expertise: "الخبرات",
    experience: "الخبرة المهنية",
    projects: "المشاريع",
    contact: "تواصل",
    menu: "فتح القائمة",
    close: "إغلاق القائمة",
  },
  hero: {
    badge: "مطوّر واجهات أمامية مستقل · غزة، فلسطين",
    greeting: "مرحباً، أنا",
    name: "بلال القطراوي",
    rolePrefix: "أبني",
    roles: [
      "منصات SaaS ولوحات تحكم",
      "مواقع تجارة إلكترونية",
      "صفحات هبوط",
      "واجهات React و Next.js عالية الأداء",
    ],
    subtitle:
      "مطوّر واجهات أمامية متخصص في React.js و Next.js. أطوّر منصات SaaS ولوحات تحكم وتطبيقات تجارة إلكترونية باستخدام Tailwind CSS و MUI  هندسة نظيفة، إدارة حالة قوية، وتكامل سلس مع REST APIs.",
    ctaPrimary: "عرض المشاريع",
    ctaSecondary: "تواصل معي",
    scroll: "مرّر للأسفل",
  },
  about: {
    title: "من أنا",
    kicker: "الخلفية والتركيز",
    headline: "واجهات أمامية جاهزة للإنتاج لمنتجات حقيقية.",
    p1: "خريج هندسة برمجيات من جامعة الأزهر بغزة، مع تدريب عملي في Java (مركز توب تك، 2021)، تطوير ويب full-stack (مركز الكويتي للتدريب، 2021)، ودراسة متقدمة عبر Udemy ومدرسة Elzero (React.js و Next.js و Redux و React Query و Tailwind CSS و REST APIs، 2022–2025).",
    p2: "مهندس واجهات أمامية متخصص في React.js و Next.js لبناء منصات SaaS عالية الأداء ومواقع الشركات ولوحات تحكم الرعاية الصحية وتطبيقات التجارة الإلكترونية. خبير في تحويل متطلبات الأعمال المعقدة إلى بنى واجهات قابلة للتوسع، وتحسين مؤشرات Core Web Vitals، وبناء تكاملات REST API سلسة. ملتزم بتقديم حلول ويب جاهزة للإنتاج، يسهل الوصول إليها، متقنة التفاصيل، وقابلة للصيانة.",
    highlights: [
      { title: "2025 – الآن", desc: "مطوّر واجهات أمامية مستقل" },
      { title: "بكالوريوس", desc: "هندسة برمجيات · جامعة الأزهر بغزة" },
      { title: "React و Next.js", desc: "SaaS · لوحات · تجارة · رعاية صحية" },
    ],
    resumeLabel: "السيرة الذاتية",
    resumeCta: "عرض السيرة الذاتية",
    resumeHref: "https://bilal-alqtrawi.github.io/BA-Portfolio/Bilal-CV.pdf",
  },
  skills: {
    title: "المهارات",
    subtitle: "مجمّعة حسب طريقة عملي عبر المكدس",
    categories: {
      languages: "اللغات",
      frameworks: "الأطر والمكتبات",
      databases: "قواعد البيانات",
      tools: "الأدوات والتسليم",
    },
    items: {
      html: "HTML5",
      css: "CSS3",
      js: "JavaScript (ES6+)",
      ts: "TypeScript",
      sass: "Sass / SCSS",
      sql: "SQL",
      react: "React.js",
      next: "Next.js (v15/16)",
      tailwind: "Tailwind CSS",
      redux: "Redux Toolkit",
      reactQuery: "React Query",
      context: "Context API",
      mui: "Material UI (MUI)",
      framer: "Framer Motion",
      shadcn: "Shadcn/UI",
      swiper: "Swiper.js",
      supabase: "Supabase",
      firebase: "Firebase",
      mysql: "MySQL",
      mongo: "MongoDB",
      git: "Git و GitHub",
      rest: "REST APIs",
      postman: "Postman / Apidog",
      vercel: "Vercel",
      netlify: "Netlify",
      ghActions: "GitHub Actions (CI/CD)",
      dns: "النطاقات و SSL",
      lighthouse: "Lighthouse والتحليل",
      a11y: "إمكانية الوصول (WCAG)",
      perf: "الأداء (Core Web Vitals)",
      aiTools: "التطوير المدعوم بالذكاء الاصطناعي",
    },
  },
  expertise: {
    title: "الخبرات",
    subtitle: "ما أقدّمه في مشاريع العملاء والمنتجات",
    cards: [
      {
        title: "SaaS ولوحات التحكم",
        body: "لوحات بصلاحيات أدوار، واجهات بيانات كثيفة، ومكتبات مكوّنات قابلة لإعادة الاستخدام مع design tokens — بـ React و React Query و Redux و Tailwind أو MUI.",
      },
      {
        title: "التجارة الإلكترونية والمواقع التسويقية",
        body: "تصفية منتجات، سلة، دفع متعدد الخطوات، أقسام hero متحركة، و skeleton loaders — مع Redux و Framer Motion وتدفقات API موثوقة.",
      },
      {
        title: "الأداء والتكامل",
        body: "تخطيطات متجاوبة، بناء متوافق مع Lighthouse، SEO عبر Next.js SSR/SSG، أنماط JWT، وتكامل REST مع نشر على Vercel.",
      },
    ],
  },
  experience: {
    eyebrow: "المسار المهني",
    title: "الخبرة والتعليم",
    subtitle:
      "الوظائف التي أعمل عليها الآن، وما سبقها من عمل، والأساس الذي شكّل مهاراتي.",
    present: "حالياً",
    current: {
      role: "مهندس واجهات أمامية ودعم تقني",
      company: "منصة معاون",
      meta: "تعاقد · عن بُعد",
      period: "ديسمبر 2025 – الآن",
      points: [
        "صمّمت هياكل واجهات أمامية معيارية وأكثر من 10 وحدات لوحة تحكم (RBAC/KYC) باستخدام React.js و Next.js و RTK و React Query لتأمين العمليات التشغيلية.",
        "ربطت أكثر من 20 نقطة REST API آمنة مع معايير تحقق صارمة عبر React Query لتبسيط معالجة المعاملات متعددة الخطوات.",
        "أتولى الدعم التقني بالساعة واستكشاف الأخطاء وصيانة الميزات لضمان توافر النظام وأدائه المستمر.",
      ],
    },
    freelance: {
      role: "مطوّر واجهات أمامية",
      company: "عمل مستقل",
      meta: "غزة، فلسطين",
      period: "2025 – الآن",
      points: [
        "سلمت أكثر من 7 تطبيقات ويب إنتاجية (SaaS، لوحات تحكم، تجارة إلكترونية) وبنيت أكثر من 15 قالباً متجاوباً للواجهات باستخدام Tailwind CSS.",
        "قلّلت زمن تحميل الصفحات بأكثر من 30% عبر استراتيجيات عرض ذكية وتخزين الاستعلامات وتحسين Core Web Vitals.",
        "استخدمت أدوات تطوير مدعومة بالذكاء الاصطناعي (Cursor و Claude Code و Gemini) لتسريع تسليم الميزات مع الحفاظ على جودة الكود.",
      ],
    },
    education: {
      title: "التعليم",
      school: "جامعة الأزهر – غزة",
      degree: "بكالوريوس هندسة البرمجيات",
      period: "الدفعة 2025",
      desc:
        "تركّزت على تطوير الويب، البرمجة كائنية التوجه، هياكل البيانات والخوارزميات، نظم قواعد البيانات، اختبار البرمجيات، الحوسبة السحابية، وهندسة المتطلبات.",
    },
    certifications: {
      title: "الشهادات والتدريب",
      items: [
        { name: "مركز Top-Tech", label: "دورة البرمجة بلغة Java", year: "2021" },
        {
          name: "مركز التدريب الكويتي",
          label: "تطوير ويب متكامل (Full Stack)",
          year: "2021",
        },
        {
          name: "Udemy (Jonas Schmedtmann)",
          label: "دورة React الشاملة 2024",
          year: "2024",
        },
        { name: "مدرسة الزيرو", label: "مسار تطوير الواجهات المتقدم", year: "" },
      ],
    },
  },
  projects: {
    title: "أعمال مختارة",
    subtitle:
      "واجهات أمامية في الإنتاج — تجارة إلكترونية، SaaS، رعاية صحية، ومواقع مؤسسية.",
    moawen: {
      title: "منصة معاون",
      shortDescription:
        "منصة عمل حر متعددة الأدوار تربط بين العملاء والمستقلين مع مركز تحكم متطور.",
      longDescription:
        "منصة عمل حر متعددة الأدوار تربط بين العملاء والمستقلين عبر تطبيق ومركز تحكم متكامل. شاركت في تطوير Landing Page ولوحة التحكم باستخدام Next.js و React و MUI مع دعم تعدد اللغات، الصلاحيات، المحادثات، إدارة المستخدمين و المشاريع والخدمات، الإشعارات، التحليلات، وإعدادات النظام الديناميكية.",
      notes: "💡 حساب الزائر للوحة التحكم: g@g.com | guest@123456",
    },
    masa: {
      title: "متجر ألعاب ماسة",
      shortDescription:
        "منصة تجارة إلكترونية متكاملة لمتجر ألعاب أطفال، تم بناؤها بـ React و Vite.",
      longDescription:
        "منصة تجارة إلكترونية متكاملة لمتجر ألعاب أطفال، تم بناؤها بـ React و Vite مع التركيز على تجربة مستخدم سلسة وسريعة. تتضمن ميزات تصفية وفرز متقدمة للمنتجات، سلة مشتريات ديناميكية، ونظام دفع متعدد الخطوات مُدار بالكامل عبر Redux Toolkit و React Hook Form. يضم الموقع حركات انسيابية بـ Framer Motion، ومقاطع سلايدر بـ Swiper، وحالات تحميل ذكية (Skeleton Loaders) مع تحسين أداء الصور عبر الـ Lazy Loading وتكامل كامل مع الـ REST APIs.",
    },
    wsl: {
      title: "منصة WSL اللوجستية",
      shortDescription:
        "صفحة هبوط متطورة ولوحة تحكم تفاعلية لإدارة بيانات السائقين.",
      longDescription:
        "صفحة هبوط متطورة مربوطة لوحة تحكم تفاعلية لإدارة بيانات السائقين، تم بناؤها باستخدام React و Tailwind v4 و Supabase. تتضمن اللوحة ميزات البحث المتقدم، التصفية الديناميكية، التبديل بين المظهر الداكن والمضيء، وتصدير البيانات مباشرة إلى ملفات Excel.",
      notes: "💡 حساب الزائر للوحة التحكم: guest@guest.com | 12345678",
    },
    arsl: {
      title: "نظام Arsl للرعاية الصحية المتكاملة",
      shortDescription:
        "منظومة صحية ضخمة لإدارة الرعاية الطبية عن بُعد والسجلات الصحية الإلكترونية.",
      longDescription:
        "منظومة صحية ضخمة (Ecosystem) لإدارة الرعاية الطبية عن بُعد والسجلات الصحية الإلكترونية (EHR)، تم تطويرها ضمن فريق 'فكرتك' لتربط بين لوحات تحكم الإدارة والأطباء وتطبيق المريض المحمول. تم بناؤها باستخدام Next.js و MUI و Redux Toolkit، ومدعومة بنظام صلاحيات دقيق (RBAC). يتضمن النظام استشارات صوتية ومرئية فورية عبر Stream SDK، محادثات حيّة بـ Socket.io، تتبع طلبات الطوارئ بالخرائط الديناميكية (Google Maps/Mapbox)، وإدارة كاملة للصيدلية والمحفظة المالية الرقمية. كما تم دمج تقنيات الذكاء الاصطناعي عبر Anthropic AI لمعالجة البيانات الطبية، مع تأمين الجلسات بالكامل بواسطة NextAuth و Prisma.",
    },
    alghaith: {
      title: "الغيث والخريف",
      shortDescription:
        'موقع تعريفي لمكتب المحاماة "الغيث والخريف" مبني بـ Next.js مع SSR و ISR.',
      longDescription:
        'موقع تعريفي متكامل لمكتب المحاماة "الغيث والخريف". تم بناؤه باستخدام Next.js والاعتماد الكامل على SSR و ISR لضمان أرشفة مثالية (SEO) وسرعة استجابة فائقة للقضايا والمقالات. يتميز الواجهة بتصميم عصري وأنيق يعكس الهوية القانونية الصارمة باستخدام Tailwind CSS و Shadcn/UI، مع إدارة سلسة للبيانات عبر Server Actions لتقديم تجربة مستخدم خالية من العوائق وبأعلى معايير الأداء (Core Web Vitals).',
    },
    qira: {
      title: "منصة قِرى (Qira)",
      shortDescription:
        "تطوير صفحة هبوط (Landing Page) تفاعلية وأصول ميديا متقدمة لمنصة Qira مع تحسينات الأداء والـ Open Graph.",
      longDescription:
        "تطوير واجهة العرض الرئيسية (Landing Page) لمنصة Qira باستخدام Next.js وTailwind CSS، مع التركيز على بناء أصول Open Graph متقدمة ومعالجة بناء الملفات والنمذجة البرمجية لضمان أفضل تجربة للمستخدم وأداء عالي.",
    },
    nexvio: {
      title: "منصة NexVio",
      shortDescription:
        "تراسل وتصميم واجهات تفاعلية تدعم العرض ثلاثي الأبعاد للخرائط وأنظمة الثيم المتعددة.",
      longDescription:
        "بناء وتطوير مكونات الواجهة التفاعلية لمنصة NexVio، وتضمين عرض الخرائط ثلاثية الأبعاد (3D Maps)، وتخصيص أنظمة المظاهر (Themes) وتناسق الألوان لتقديم تجربة مستخدم سلسة وعصرية.",
    },
    demo: "الموقع المباشر",
    code: "المصدر",
    details: "عرض التفاصيل",
    dialog: {
      closeAria: "إغلاق",
    },
    privateRepoNote:
      "هذا المستودع خاص. الوصول محدود للمشاركين المصرّح لهم فقط.",
  },
  contact: {
    title: "تواصل",
    subtitle: "صف منتجك والجدول الزمني والأهداف.",
    infoTitle: "مباشر",
    formTitle: "رسالة",
    fullName: "بلال القطراوي",
    phoneValue: "059 309 4894",
    emailValue: "bbill4552@gmail.com",
    name: "الاسم",
    namePh: "اسمك",
    email: "البريد",
    emailPh: "you@company.com",
    phone: "الهاتف / واتساب",
    phonePh: "اختياري",
    whatsapp: "واتساب",
    subject: "الموضوع",
    subjectPh: "مشروع / وظيفة / تعاون",
    message: "الرسالة",
    messagePh: "ماذا سنبني؟",
    success: "جاري فتح بريدك…",
    successTitle: "تم إرسال الرسالة!",
    successBody: "شكراً لتواصلك — سأعود إليك في أقرب وقت ممكن.",
    successCta: "إرسال رسالة أخرى",
    errorRequired: "البريد مطلوب.",
    social: "التواصل",
    location: "غزة، فلسطين",
  },
  footer: {
    rights: "صُنع بعناية.",
    builtBy: "بلال القطراوي",
    connect: "تواصل",
  },
  toast: {
    sent: "شكراً — مسودة جاهزة للإرسال.",
    needEmail: "يرجى إدخال بريد صالح.",
    errorSubmit: "حدث خطأ ما. حاول مجدداً لاحقاً.",
  },
};

export default ar;
